import { track } from '../../analytics/helpers';
import * as types from './keys';

type Trait = { [key: string]: string };

export const trackCreateUGCDraftClick = (traits?: Trait) => {
  track(types.SUBMIT_CREATE_UGC_DRAFT_CLICK, traits);
};

export const trackCreateUGCDraftCancel = (traits?: Trait) => {
  track(types.SUBMIT_CREATE_UGC_DRAFT_CANCEL_CLICK, traits);
};
